import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components/native';
import moment from 'moment';
import Text from '../text';
import Colors from '../colors';
import Spacer from '../spacer';
import LabelDataPair from '../label-data-pair';
import Icon from '../icon';
import Status from '../status';
import useMobile from '../hooks/use-mobile';
import Currency from '../utilities/currency';
const StyledContainer = styled.Pressable`
  flex-direction: row;
  justify-content: space-between;
  padding: 12px ${props => props.paddingHorizontal}px;
  background-color: ${Colors.lightGray100};
  width: 100%;
`;
const StyledIcon = styled.View`
  width: ${props => props.size}px;
  height: ${props => props.size}px;
  background-color: ${Colors.lightGray200};
  border-radius: 4px;
  justify-content: center;
  align-items: center;
`;
const IconDescriptionContainer = styled.View`
  flex-direction: row;
  align-items: center;
`;
const AmountDueContainer = styled.View`
  flex-direction: column;
  alignItems: flex-end;
  justify-content: center;
`;

const formatDate = date => `Originally Due: ${moment(date).format('MMM DD')}`;

const devices = {
  desktop: {
    containerPaddingHorizontal: 16,
    iconContainerSize: 32,
    iconSize: 20
  },
  mobile: {
    containerPaddingHorizontal: 12,
    iconContainerSize: 24,
    iconSize: 15
  }
};
export default function Payment(props) {
  const mobile = useMobile();
  const device = mobile ? devices.mobile : devices.desktop;
  const label = props.partialPayment ? props.paid ? `Paid on ${props.dueDate}` : `Pay on ${props.dueDate}` : `Payment ${props.paymentNo} of ${props.paymentCount}`;
  return /*#__PURE__*/React.createElement(StyledContainer, {
    paddingHorizontal: device.containerPaddingHorizontal,
    onPress: props.onPress
  }, /*#__PURE__*/React.createElement(IconDescriptionContainer, null, /*#__PURE__*/React.createElement(StyledIcon, {
    size: device.iconContainerSize
  }, /*#__PURE__*/React.createElement(Icon.AdvanceLineIcon, {
    name: props.icon,
    color: Colors.advanceBlue400,
    size: device.iconSize
  })), /*#__PURE__*/React.createElement(Spacer, {
    size: "f12",
    width: true
  }), /*#__PURE__*/React.createElement(LabelDataPair, {
    type: "top-left",
    size: "small",
    label: label
  }, props.purpose)), /*#__PURE__*/React.createElement(AmountDueContainer, null, props.paid && /*#__PURE__*/React.createElement(Status, {
    type: "success"
  }, "Paid") || /*#__PURE__*/React.createElement(Text.BodyBase, {
    color: Colors.gray500
  }, Currency.pesoFormat(props.amount)), props.carryOver && props.dueDate && /*#__PURE__*/React.createElement(IconDescriptionContainer, null, /*#__PURE__*/React.createElement(Icon.MaterialIcons, {
    name: "circle",
    size: 8,
    color: Colors.warning400
  }), /*#__PURE__*/React.createElement(Spacer, {
    size: "f4",
    width: true
  }), /*#__PURE__*/React.createElement(Text.BodySmall, {
    color: Colors.gray400
  }, formatDate(props.dueDate)))));
}
Payment.propTypes = {
  icon: PropTypes.string,
  purpose: PropTypes.string,
  paymentNo: PropTypes.number,
  paymentCount: PropTypes.number,
  amount: PropTypes.number,
  dueDate: PropTypes.instanceOf(Date),
  carryOver: PropTypes.bool,
  onPress: PropTypes.func,
  partialPayment: PropTypes.bool,
  paid: PropTypes.bool
};
Payment.defaultProps = {
  icon: 'Others',
  purpose: 'Others',
  paymentNo: 0,
  paymentCount: 0,
  amount: 0,
  dueDate: null,
  carryOver: false,
  onPress: undefined,
  partialPayment: false,
  paid: false
};
//# sourceMappingURL=payment.js.map